import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { IColumn } from '../../../../shared/models/list-models';
import { IDropdownOption } from '../../../../../../projects/shared/nvps-libraries/design/interfaces/design-library.interface';
import { ITermDetails } from '../student-credit-gaps-panel-course-history/student-credit-gaps-panel-course-history.component';

export enum TableKebabType {
  // eslint-disable-next-line no-unused-vars
  COURSE_HISTORY = 'CREDIT_GAPS_COURSE_HISTORY',
  // eslint-disable-next-line no-unused-vars
  CURRENT_PROGRAM = 'CREDIT_GAPS_CURRENT_PROGRAM',
  // eslint-disable-next-line no-unused-vars
  FUTURE_PROGRAM = 'CREDIT_GAPS_FUTURE_PROGRAM',
}

export type TTableKebabType = TableKebabType.COURSE_HISTORY | TableKebabType.CURRENT_PROGRAM | TableKebabType.FUTURE_PROGRAM;

export interface ICreditGapsKebabInput {
  config: any;
  kebabType: TTableKebabType;
  defaultOptions?: string[];
  termYearTypes?: { CURRENT: ITermDetails; NEXT: ITermDetails; FUTURE: ITermDetails };
}

@Component({
  selector: 'credit-gaps-kebab',
  templateUrl: './student-credit-gaps-kebab.component.html',
  encapsulation: ViewEncapsulation.None,
})

export class StudentCreditGapsKebabComponent implements OnInit {
  constructor () { }

  @Input() input: { row: any[]; column: IColumn; dynamicComponentInputData?: any };
  @Output() output = new EventEmitter();

  public options: IDropdownOption[] = [];
  public config: any;
  public overlapTrigger: boolean = true;
  public termYearTypes: { CURRENT: ITermDetails; NEXT: ITermDetails; FUTURE: ITermDetails };

  public ngOnInit (): void {
    if (this.input) {
      this.setUI();
    }
  }

  ngOnChanges (): void {
    if (this.input) {
      this.setUI();
    }
  }

  private setUI (): void {
    const { row, dynamicComponentInputData: { config, defaultOptions, kebabType, termYearTypes } } = this.input;
    this.config = config;
    this.options = this.filterOptions({
      options: Object.values(config.options),
      defaultOptions,
      row,
      kebabType,
    });
    this.termYearTypes = termYearTypes;
  }

  public onSelect (e: string): void {
    const { ADD_TO_THIS_TERM, ADD_TO_NEXT_TERM, ADD_TO_FUTURE_TERM, DROP_COURSE, UNDO_ADD_DROP_COURSE, EDIT_COURSE } = this.config.options;
    const { kebabType } = this.input.dynamicComponentInputData;
    let action: string;
    switch (e) {
      case ADD_TO_THIS_TERM?.key: {
        action = ADD_TO_THIS_TERM?.action;
        break;
      }
      case ADD_TO_NEXT_TERM?.key: {
        action = ADD_TO_NEXT_TERM?.action;
        break;
      }
      case ADD_TO_FUTURE_TERM?.key: {
        action = ADD_TO_FUTURE_TERM?.action;
        break;
      }
      case DROP_COURSE?.key: {
        action = DROP_COURSE?.action;
        break;
      }
      case UNDO_ADD_DROP_COURSE?.key: {
        action = UNDO_ADD_DROP_COURSE?.action;
        break;
      }
      case EDIT_COURSE?.key: {
        action = EDIT_COURSE?.action;
        break;
      }
      default: {
        action = '';
        break;
      }
    }

    this.output.emit({
      action,
      kebabType,
      course: this.input.row,
    });
  }

  private filterOptions ({ options, defaultOptions, row, kebabType }:
    {
      options: IDropdownOption[],
      defaultOptions: string[],
      row: any,
      kebabType: string
    }): IDropdownOption[] {
    let optionsForKebab = options;
    const shouldFilter = kebabType === TableKebabType.CURRENT_PROGRAM;
    if (shouldFilter) {
      const statusRow = row.find(item => item.key === 'STATUS');
      const status = statusRow ? statusRow.value : null;
      if ((status && status.includes('Pending'))) {
        optionsForKebab = options.filter((option) => {
          return !defaultOptions.includes(option.key);
        });
      } else {
        optionsForKebab = options.filter((option) => {
          return defaultOptions.includes(option.key);
        });
      }
    }
    return optionsForKebab;
  }
}
